import { render, staticRenderFns } from "./booking.vue?vue&type=template&id=201d5062&scoped=true"
import script from "./booking.vue?vue&type=script&lang=js"
export * from "./booking.vue?vue&type=script&lang=js"
import style0 from "./booking.vue?vue&type=style&index=0&id=201d5062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201d5062",
  null
  
)

export default component.exports